module.exports = __webpack_public_path__ + "media/images/pag-left-gray-b368c96c4cdf38c74a20acf13c9c7e2a.png";